export const environment = {
    production: false,
    development: false, // Set to true if you are developing locally
    showDebugTrace: true, // Set to false if you don't want to see debug trace in console
    apiUrl: 'https://dev.new-dispo.nagel.p3ds.net',
    sessionRenewalTime: 50, // in seconds
    keycloak: {
        config: {
            url: 'https://dev-dispo.gcp.nagel-group.com/keycloak',
            realm: 'master',
            clientId: 'cal-client'
        },
        loadUserProfileAtStartUp: true,
        initOptions: {
            enableLogging: true,
            checkLoginIframe: false,
            onLoad: 'login-required',
            // silentCheckSsoRedirectUri:
            //     window.location.origin + '/en-US/assets/silent-check-sso.html',
            flow: 'standard',
            useNonce: false
            //pkceMethod: 'S256',  // Enable PKCE
        }
    }
};